import React from "react";
import "./App.css";
import PublicRoutes from "./routes/publicRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
 
 
  return (
    <div className="App" style={{ background: "var(--main-bg)" }}>
      <PublicRoutes />
      <ToastContainer />
    </div>
  );
}

export default App;
